import { GiftItemType, GiftOrderRequest } from '@models/gift';

export function parseGiftOrderRequest(originalRequest?: string): GiftOrderRequest | undefined {
    try {
        const request: GiftOrderRequest = JSON.parse(originalRequest!);
        const item = request.giftOrderItems?.[0];
        if (!item?.giftItemId || !Number.isInteger(item.count) || item.count < 1
            || typeof request.userName !== 'string' || typeof request.userPhone !== 'string'
            || !Array.isArray(request.giftRecipients)
            || !request.giftRecipients.every((recipient) => (
                typeof recipient?.name === 'string' && typeof recipient?.phoneNo === 'string'
            ))) return undefined;
        return request;
    } catch {
        return undefined;
    }
}

export function getGiftOrderRestoreParams(originalRequest?: string) {
    const request = parseGiftOrderRequest(originalRequest);
    if (!request) return undefined;
    const { giftItemId, count } = request.giftOrderItems[0];
    return {
        type: typeof request.cardName === 'string' || request.giftCardImageId
            ? GiftItemType.CASH : GiftItemType.PRODUCT,
        giftItemId,
        qty: count,
        giftCardImageId: request.giftCardImageId,
        originalRequest,
    };
}
